/**
 * @license
 * Copyright 2026 okayest! studios LLC. All Rights Reserved.
 */

/** Light haptic tick on devices that support the Vibration API. */
export function vibrate(): void {
  navigator.vibrate?.(10);
}
